import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-[34px] h-11 leading-11 font-bold mb-4" }, " История операций ", -1)

import { usePermissions } from "@/use/usePermissions";

import UiApp from "@/plugins/ui/components/app/UiApp.vue";
import UiAppbar from "@/plugins/ui/components/appbar/UiAppbar.vue";
import UiPlaceholder from "@/plugins/ui/components/placeholder/UiPlaceholder.vue";

import UiIconBtn from "@/components/ui/UiIconBtn.vue";

import AppTabbar from "@/components/AppTabbar.vue";
import AppSidebar from "@/components/AppSidebar.vue";
import OperationsList from "../components/OperationsList.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OperationsPage',
  setup(__props) {

const { isAllow, getDenyType } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiApp, null, {
    header: _withCtx(() => [
      _createVNode(UiAppbar, {
        temporary: "",
        title: "История операций"
      }, {
        right: _withCtx(() => [
          _createVNode(UiIconBtn, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace('/settings'))),
            variant: "tertiary",
            icon: "Cog"
          })
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(AppTabbar)
    ]),
    sidebar: _withCtx(() => [
      _createVNode(AppSidebar)
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      (_unref(isAllow)('score_operation'))
        ? (_openBlock(), _createBlock(OperationsList, { key: 0 }))
        : (_unref(getDenyType)('score_operation') === 'unsupported')
          ? (_openBlock(), _createBlock(UiPlaceholder, {
              key: 1,
              icon: "ChartSquareBar",
              title: "Модуль «История операций» недоступен",
              description: "К сожалению, модуль «История операций» не подключен к вашей школе."
            }))
          : (_unref(getDenyType)('score_operation') === 'subscription')
            ? (_openBlock(), _createBlock(UiPlaceholder, {
                key: 2,
                icon: "ChartSquareBar",
                title: "Модуль «История операций» доступен по подписке",
                description: "Модуль «История операций» будет доступен после оформления расширенной подписки."
              }))
            : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})